<div #panelContainer class="ax-side-panel__container" [ngClass]="setClasses()" [tabIndex]="tabIndex">
    <ng-content></ng-content>
</div>
